'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var Apollo = require('@apollo/client');
var error = require('@apollo/client/link/error');
var apolloClientFactory = require('@narvar/apollo-client');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var apolloClientFactory__default = /*#__PURE__*/_interopDefaultLegacy(apolloClientFactory);

async function createClient(_ref) {
  let {
    uri,
    handleError
  } = _ref;
  const {
    client,
    startCacheTtlChecker
  } = await apolloClientFactory__default["default"]({
    fetch,
    uri,
    ssrMode: false,
    addTypename: true,
    maxBatch: 20,
    disablePersistedCache: true,
    link: _ref2 => {
      let {
        retry,
        batch,
        rest
      } = _ref2;
      const error$1 = error.onError(_ref3 => {
        let {
          graphQLErrors,
          networkError,
          operation
        } = _ref3;
        if (graphQLErrors) {
          graphQLErrors.forEach(_ref4 => {
            let {
              message,
              locations,
              path
            } = _ref4;
            return handleError(`[GraphQL error]: OperationName: ${operation.operationName} Message: ${message}, Location: ${JSON.stringify(locations)}, Path: ${JSON.stringify(path)}, Variables: ${JSON.stringify(operation.variables)}`);
          });
        }
        if (networkError) {
          const {
            response
          } = networkError;
          handleError(`[GraphQL network error]: OperationName: ${operation.operationName} Message: ${JSON.stringify(networkError)}${response ? `, Headers: ${JSON.stringify([...response.headers.entries()])}` : ''}`);
        }
      });
      return Apollo.from([rest, retry, error$1, batch]);
    }
  });
  startCacheTtlChecker();
  return client;
}
const useLomaClient = _ref5 => {
  let {
    lomaUrl,
    handleError
  } = _ref5;
  const [state, setState] = React.useState({});
  React.useEffect(() => {
    createClient({
      uri: lomaUrl,
      handleError
    }).then(client => setState({
      client
    }), error => setState({
      error
    }));
  }, [lomaUrl, handleError]);
  return state;
};

exports["default"] = useLomaClient;
